module.exports = __webpack_public_path__ + "static/img/43031.d1c2e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/43031.jpg
// module id = SDnY
// module chunks = 1